import { render, staticRenderFns } from "./DispositionModalSimple.vue?vue&type=template&id=540ec47b&"
import script from "./DispositionModalSimple.vue?vue&type=script&lang=js&"
export * from "./DispositionModalSimple.vue?vue&type=script&lang=js&"
import style0 from "./DispositionModalSimple.vue?vue&type=style&index=0&id=540ec47b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports